import * as types from '../../action-types';
import { withHansaCreateLink as initialState } from "../../initialState";

const withHansaCreateLink = (state=initialState, action) => {  
  switch (action.type) {    
    case types.WITH_HAMSA_CREATE_LINK_FAIL:
      return {
        ...state,
        isLoading: false,
        data: '',
        error: action.payload,
        isSuccessful:false
      }; 
    case types.WITH_HAMSA_CREATE_LINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: '',
        isSuccessful:true
      }; 
    default:
      return state;
  }
}

export default withHansaCreateLink;
